import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { addDesktopElement, updateDesktopElement } from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import { connect } from 'react-redux';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import { getElementPreset } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';

@connect(
  false,
  {closeLazyPanel, addDesktopElement, updateDesktopElement}
)
export default class ElementDialogWrapper extends Component {
  constructor(props) {
    super(props);

    this.onCancel = this.onCancel.bind(this);
    this.onAddUpdate = this.onAddUpdate.bind(this);
  }

  onCancel() {
    const { panelName, closeLazyPanel, onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
    closeLazyPanel(panelName);
  }

  onAddUpdate(elementProps) {
    const { panelName, newElement, closeLazyPanel, onAddUpdate } = this.props;
    if (newElement) {
      window.setTimeout(this.handleAddElement.bind(this, elementProps), 190); // 190ms delay to allow added element animation to start when the dialog is not fully visible.
    } else {
      this.handleUpdateElement(elementProps);
    }
    if (onAddUpdate) {
      onAddUpdate();
    }
    closeLazyPanel(panelName);
  }

  handleAddElement(elementProps) {
    const { addDesktopElement, addElementProps } = this.props;
    addDesktopElement(addElementProps.elementType, addElementProps.elementPosition, elementProps);
  }

  handleUpdateElement(elementProps) {
    const { updateDesktopElement, updateElementProps } = this.props;
    updateDesktopElement(updateElementProps.selectedElement.id, elementProps);
  }

  render() {
    const {addElementProps, newElement} = this.props;
    const childrenProps = {
      onAddUpdate: this.onAddUpdate,
      onCancel: this.onCancel,
    };
    if (newElement) {
      childrenProps.selectedElement = getElementPreset(addElementProps.elementType);
    }
    const childrenWithProps = React.Children.map(this.props.children,
      (child) => React.cloneElement(child, childrenProps));
    return (
      <div>{childrenWithProps}</div>
    );
  }
}

ElementDialogWrapper.propTypes = {
  updateElementProps: PropTypes.object.isRequired,
  addElementProps: PropTypes.object.isRequired,
  panelName: PropTypes.string.isRequired,
  newElement: PropTypes.bool.isRequired,
  onAddUpdate: PropTypes.func,
  onCancel: PropTypes.func
};

ElementDialogWrapper.defaultProps = {
  valid: true,
  newElement: false
};